import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { DataValidation } from '@model/data-validation';
import { routes } from '@model/constants/routes';
import { CustomResponseDto } from '@core/model/custom-response-dto';
import { NavigableResponse } from '@credit/data-validation/model/navigable-response';

@Injectable({
  providedIn: 'root',
})
export class DataValidationService {
  apiUrl = environment.apiGatewayUrl;

  constructor(private http: HttpClient) {}

  public DataValidationService(dataValidation: DataValidation): Observable<CustomResponseDto<NavigableResponse>> {
    const data = {
      termAndConditions: dataValidation.termAndConditions,
      productType: dataValidation.productType,
      token: dataValidation.token,
      origin: dataValidation.origin,
      amount: dataValidation.amount,
      term: dataValidation.term,
    };

    return this.http.post<CustomResponseDto<NavigableResponse>>(this.apiUrl + routes.DataValidationService, data, {
      headers: getHttpHeaders(),
    });
  }
}
